import { render, staticRenderFns } from "./PackageIncludedCarousel.vue?vue&type=template&id=c3d3d23c&scoped=true&"
import script from "./PackageIncludedCarousel.vue?vue&type=script&lang=ts&"
export * from "./PackageIncludedCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PackageIncludedCarousel.vue?vue&type=style&index=0&id=c3d3d23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d3d23c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
